export const DESKTOP = 'desktop';
export const MOBILE = 'mobile';
export const TABLET = 'tablet';
